import { render, staticRenderFns } from "./LabelCreate.vue?vue&type=template&id=c79d6ce6&lang=pug"
import script from "./LabelCreate.vue?vue&type=script&lang=js"
export * from "./LabelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports